<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-secondary">
                  {{ getConfigStatus() }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row">
              <input-text v-model="name" :options="{ id: 'name', label: 'name', disabled: true }"/>
              <select-allocation-config-types v-model="type" :options="{ id: 'type', label: 'type', disabled: true }"/>
              <select-suppliers v-if="['SUPPLIER','SUPPLIER_CITY'].includes(type)" v-model="supplier_id" :includeFreelancers="false" :options="{ id: 'supplier_id', label: 'supplier', disabled: true }"/>
              <select-countries v-if="['COUNTRY','CITY','ZONE','SUPPLIER_CITY'].includes(type)" v-model="country_id" :options="{ id: 'country_id', label: 'country', disabled: true }"/>
              <select-cities v-if="['CITY','ZONE','SUPPLIER_CITY'].includes(type)" v-model="city_id" :country_id="country_id" :options="{ id: 'city_id', label: 'city', disabled: true }"/>
              <select-zones v-if="['ZONE'].includes(type)" v-model="zone_id" :city_id="city_id" :options="{ id: 'zone_id', label: 'zone', disabled: true }"/>
              <select-platforms v-if="['PLATFORM'].includes(type)" v-model="platform_id" :options="{ id: 'platform_id', label: 'platform', disabled: true }"/>
            </div>
            <allocation-config-tiers-list v-if="!serverError" v-model="tiers" :editable="false" />
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound() && this.versionStatus === 'future'" @click.prevent="cancel" class="btn btn-primary btn-sm" :disabled="loading" v-b-tooltip.hover="{ animation: false}" :title="getCancelActionHint()">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-reply"></i>
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ALLOCATION_CONFIGS_SHOW,
  FUTURE_ALLOCATION_CONFIGS_DELETE,
  FUTURE_ALLOCATION_CONFIGS_SHOW
} from 'actions/allocation_configs';
  import AllocationConfigTiersList from './partials/allocation_tiers';

  const CRUD_CODE="allocation_configs";
  export default {
    name: "AllocationConfigShow",
    components: {
      AllocationConfigTiersList
    },
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: 'settings',
        id: this.$router.currentRoute.params.id,
        versionStatus: this.$router.currentRoute.params.versionStatus,
        tiers: [],
        country_id: '',
        city_id:'',
        zone_id:'',
        platform_id:'',
        supplier_id:'',
        type:'',
        name:'',
        action:'',
        applied_at:'',
        serverError: '',
        responseStatus:'',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        const action = this.versionStatus === 'future' ? FUTURE_ALLOCATION_CONFIGS_SHOW : ALLOCATION_CONFIGS_SHOW;
        this.$store.dispatch(action,{
          id: this.id,
        }).then(response=>{
          this.tiers = response.data.tiers.sort((a, b) => a.level - b.level);
          this.country_id = response.data.countryId;
          this.city_id = response.data.cityId;
          this.zone_id = response.data.zoneId;
          this.platform_id = response.data.platformId;
          this.supplier_id = response.data.supplierId;
          this.name = response.data.name;
          this.type = response.data.type;
          this.action = response.data.action;
          this.applied_at = this.$moment(response.data.appliedAt).format("Y-MM-DD hh:mm:ss A");
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      cancel() {
        this.loading = true;
        this.$store.dispatch(FUTURE_ALLOCATION_CONFIGS_DELETE, { id: this.id })
            .then(() => {
              swal({
                icon: 'success',
                text: this.$i18n.t("messages.cancel_successfully"),
                buttons:false,
                timer: 5000
              });
              this.$router.push({ name: `${this.routePrefix}.index` })
            })
            .catch(error => {
              this.loading = false;
              let message="";
              if(error.response){
                let responseData=error.response.data;

                if(responseData.errors && responseData.errors.error){
                  message = responseData.errors.error;
                }
                else{
                  message = this.$i18n.t("messages.cancel_error");
                }
              }
              if(message){
                swal({
                  icon: 'error',
                  text: message,
                  buttons:false,
                  timer: 5000
                });
              }
            })
      },
      getCancelActionHint() {
        const status = this.action.toLowerCase();
        return this.$i18n.t(`allocation_configs.tooltip.cancel_action_${status}`);
      },
      getConfigStatus() {
        const status = this.action?.toLowerCase() || this.versionStatus;
        return this.$i18n.t(`allocation_configs.tooltip.config_status_${status}`, [this.applied_at]);
      }
    }
  };
</script>
